<script>
  import {
    geos,
    geos_class,
    geos_map,
    live,
    nicks_list,
    poli,
    units_list,
  } from "./stores.js";
  import { onMount, onDestroy } from "svelte";
  import {
    EXT_OMNI_GEOC_URL,
    fetchJsonSafe,
  } from "./external-service-urls.js";
  import { searchGeofence } from "./geofence-search.js";

  const LIST_REFRESH_MS = 2000;
  const GEOCODE_CONCURRENCY = 4;
  const TORRE_GEOCODE_CACHE_KEY = "__vector_torre_geocode_cache__";
  const SCORE_CONFIG_KEY = "torre_score_config";
  const default_score_config = {
    weight_any_change: 10,
    weight_ignition_change: 20,
    weight_movement_start: 20,
    weight_movement_stop: 20,
    weight_high_speed: 20,
    high_speed_threshold: 80,
    weight_no_report: 30,
    no_report_minutes_on: 15,
    no_report_minutes_off: 60,
    score_decay: 1,
    score_max: 50,
  };

  let map = 0;
  let marquee;
  let control;
  let lista_;
  let cancel_initial_lista = null;

  var table_pos_ = [];
  let last_pos_geo = get_torre_geocode_cache();
  let live_st = {};
  let loop_msg = {};
  let points_pos = {};
  let table_pos_p = [];
  let geocode_queue = [];
  let geocode_queue_index = Object.create(null);
  let geocode_inflight_index = Object.create(null);
  let geocode_inflight_count = 0;
  let geocode_pump_timer = null;

  let table_pos_f = !window.localStorage.getItem("filtro_torre")
    ? []
    : JSON.parse(window.localStorage.getItem("filtro_torre"));
  let table_pos_filter_set = new Set(table_pos_f);
  let filtro_modal = false;
  let score_modal = false;
  let units_list_p = [];
  let score_config = load_score_config();
  let score_config_form = { ...score_config };

  onMount(() => {
    function initMap() {
      map = new google.maps.Map(document.getElementById("map"), {
        center: { lat: 24.458489, lng: -102.217231 },
        zoom: 5,
      });
    }
    //initMap();
    cancel_initial_lista = schedule_after_paint(() => {
      lista();
      lista_ = setInterval(lista, LIST_REFRESH_MS);
    });

    marquee = new dynamicMarquee.Marquee(document.getElementById("marquee"), {
      rate: -100,
      upDown: false,
      startOnScreen: false,
    });
    control = dynamicMarquee.loop(marquee, [() => " Torre de control | "]);
  });

  onDestroy(() => {
    clearInterval(lista_);
    if (cancel_initial_lista) {
      cancel_initial_lista();
      cancel_initial_lista = null;
    }
    if (geocode_pump_timer != null) {
      clearTimeout(geocode_pump_timer);
      geocode_pump_timer = null;
    }
    geocode_queue = [];
    geocode_queue_index = Object.create(null);
    if (control != null) {
      control.update([]);
    }
    control = null;
    marquee = null;
  });

  function get_torre_geocode_cache() {
    if (typeof window === "undefined") {
      return {};
    }
    let cache = window[TORRE_GEOCODE_CACHE_KEY];
    if (!cache || typeof cache !== "object") {
      cache = {};
      window[TORRE_GEOCODE_CACHE_KEY] = cache;
    }
    return cache;
  }

  function schedule_after_paint(callback) {
    let frame_id = null;
    let timeout_id = null;
    if (
      typeof window !== "undefined" &&
      typeof window.requestAnimationFrame === "function"
    ) {
      frame_id = window.requestAnimationFrame(() => {
        frame_id = null;
        timeout_id = window.setTimeout(() => {
          timeout_id = null;
          callback();
        }, 0);
      });
    } else {
      timeout_id = setTimeout(() => {
        timeout_id = null;
        callback();
      }, 0);
    }
    return () => {
      if (
        frame_id != null &&
        typeof window !== "undefined" &&
        typeof window.cancelAnimationFrame === "function"
      ) {
        window.cancelAnimationFrame(frame_id);
      }
      if (timeout_id != null) {
        clearTimeout(timeout_id);
      }
    };
  }

  function read_int(value, fallback, min = 0) {
    let number = parseInt(value, 10);
    if (isNaN(number)) return fallback;
    if (number < min) return min;
    return number;
  }

  function normalize_score_config(config) {
    config = config || {};
    return {
      weight_any_change: read_int(
        config.weight_any_change,
        default_score_config.weight_any_change
      ),
      weight_ignition_change: read_int(
        config.weight_ignition_change,
        default_score_config.weight_ignition_change
      ),
      weight_movement_start: read_int(
        config.weight_movement_start,
        default_score_config.weight_movement_start
      ),
      weight_movement_stop: read_int(
        config.weight_movement_stop,
        default_score_config.weight_movement_stop
      ),
      weight_high_speed: read_int(
        config.weight_high_speed,
        default_score_config.weight_high_speed
      ),
      high_speed_threshold: read_int(
        config.high_speed_threshold,
        default_score_config.high_speed_threshold
      ),
      weight_no_report: read_int(
        config.weight_no_report,
        default_score_config.weight_no_report
      ),
      no_report_minutes_on: read_int(
        config.no_report_minutes_on,
        default_score_config.no_report_minutes_on,
        1
      ),
      no_report_minutes_off: read_int(
        config.no_report_minutes_off,
        default_score_config.no_report_minutes_off,
        1
      ),
      score_decay: read_int(config.score_decay, default_score_config.score_decay),
      score_max: read_int(config.score_max, default_score_config.score_max, 1),
    };
  }

  function load_score_config() {
    let config_raw = window.localStorage.getItem(SCORE_CONFIG_KEY);
    if (!config_raw) {
      return { ...default_score_config };
    }
    try {
      let config_saved = JSON.parse(config_raw);
      return normalize_score_config(config_saved);
    } catch (error) {
      return { ...default_score_config };
    }
  }

  function build_geocode_request_key(lat, lon) {
    return lat + "," + lon;
  }

  function format_reverse_geocode_address(dir_p) {
    if (!dir_p || typeof dir_p.address == "undefined") {
      return null;
    }
    return (
      (typeof dir_p.address.suburb != "undefined" &&
      typeof dir_p.address.road == "undefined"
        ? dir_p.address.suburb + ", "
        : "") +
      (typeof dir_p.address.road != "undefined" ? dir_p.address.road + ", " : "") +
      (typeof dir_p.address.county != "undefined"
        ? dir_p.address.county + ", "
        : "") +
      (typeof dir_p.address.state != "undefined" ? dir_p.address.state : "")
    );
  }

  function queue_geocode(modid, lat, lon, request_key) {
    if (
      geocode_queue_index[modid] === request_key ||
      geocode_inflight_index[modid] === request_key
    ) {
      return;
    }
    geocode_queue_index[modid] = request_key;
    geocode_queue.push({ modid, lat, lon, request_key });
    pump_geocode_queue();
  }

  function pump_geocode_queue() {
    if (geocode_pump_timer != null) {
      return;
    }
    geocode_pump_timer = setTimeout(() => {
      geocode_pump_timer = null;
      while (
        geocode_inflight_count < GEOCODE_CONCURRENCY &&
        geocode_queue.length > 0
      ) {
        let next_geocode = geocode_queue.shift();
        if (!next_geocode) {
          continue;
        }
        if (geocode_queue_index[next_geocode.modid] !== next_geocode.request_key) {
          continue;
        }
        delete geocode_queue_index[next_geocode.modid];
        geocode_inflight_index[next_geocode.modid] = next_geocode.request_key;
        geocode_inflight_count = geocode_inflight_count + 1;
        fetchJsonSafe(
          EXT_OMNI_GEOC_URL + "/reverse?lat=" +
            next_geocode.lat +
            "&lon=" +
            next_geocode.lon +
            "&format=json&polygon_text=1",
          { fallback: null, logLabel: "torre geocode" }
        )
          .then(function (dir_p) {
            let dir_f = format_reverse_geocode_address(dir_p);
            if (!dir_f) {
              return;
            }
            if (
              typeof last_pos_geo[next_geocode.modid] == "undefined" ||
              last_pos_geo[next_geocode.modid][3] !== next_geocode.request_key
            ) {
              return;
            }
            last_pos_geo[next_geocode.modid][2] = dir_f;
          })
          .finally(function () {
            geocode_inflight_count = geocode_inflight_count - 1;
            if (
              geocode_inflight_index[next_geocode.modid] ===
              next_geocode.request_key
            ) {
              delete geocode_inflight_index[next_geocode.modid];
            }
            if (geocode_queue.length > 0) {
              pump_geocode_queue();
            }
          });
      }
    }, 0);
  }

  function get_score(modid) {
    return typeof points_pos[modid] == "number" ? points_pos[modid] : 0;
  }

  function rebuild_ranked_table(table_pos_live) {
    let previous_index_by_modid = Object.create(null);
    let live_order_by_modid = Object.create(null);
    let next_rows = [];
    let live_order = 0;

    for (let index = 0; index < table_pos_p.length; index++) {
      if (
        typeof table_pos_p[index] != "undefined" &&
        typeof table_pos_p[index].modid != "undefined"
      ) {
        previous_index_by_modid[table_pos_p[index].modid] = index;
      }
    }

    for (let modid in table_pos_live) {
      live_order_by_modid[modid] = live_order;
      live_order = live_order + 1;
      next_rows.push(table_pos_live[modid]);
    }

    next_rows.sort((a, b) => {
      let score_diff = get_score(b.modid) - get_score(a.modid);
      if (score_diff !== 0) {
        return score_diff;
      }
      let previous_a = previous_index_by_modid[a.modid];
      let previous_b = previous_index_by_modid[b.modid];
      if (typeof previous_a == "number" && typeof previous_b == "number") {
        return previous_a - previous_b;
      }
      if (typeof previous_a == "number") {
        return -1;
      }
      if (typeof previous_b == "number") {
        return 1;
      }
      return live_order_by_modid[a.modid] - live_order_by_modid[b.modid];
    });

    for (let index = 0; index < next_rows.length; index++) {
      let previous_index = previous_index_by_modid[next_rows[index].modid];
      if (typeof previous_index != "number") {
        next_rows[index].level_c = 0;
      } else if (previous_index > index) {
        next_rows[index].level_c = 1;
      } else if (previous_index < index) {
        next_rows[index].level_c = -1;
      } else {
        next_rows[index].level_c = 0;
      }
    }

    table_pos_p = next_rows;
    table_pos_ = [...next_rows];
  }

  function get_unit_label(modid) {
    return typeof $nicks_list[modid] != "undefined" ? $nicks_list[modid] : modid;
  }

  function lista() {
    let table_pos_live = Object.create(null);
    let no_report_seconds_on = score_config.no_report_minutes_on * 60;
    let no_report_seconds_off = score_config.no_report_minutes_off * 60;
    let now_seconds = Date.now() / 1000;

    for (let x in $live) {
      if (typeof $live[x] == "undefined") {
        continue;
      }
      let modid = $live[x].modid;
      let geocode_request_key = build_geocode_request_key($live[x].lat, $live[x].lon);
      let update_now = false;
      if (typeof last_pos_geo[modid] == "undefined") {
        last_pos_geo[modid] = [
          $live[x].lat,
          $live[x].lon,
          $live[x].lat + ", " + $live[x].lon,
          geocode_request_key,
        ];
        update_now = true;
      } else {
        if (typeof last_pos_geo[modid][2] == "undefined") {
          last_pos_geo[modid][2] = $live[x].lat + ", " + $live[x].lon;
        }
        if (typeof last_pos_geo[modid][3] == "undefined") {
          last_pos_geo[modid][3] = build_geocode_request_key(
            last_pos_geo[modid][0],
            last_pos_geo[modid][1]
          );
        }
        if (
          get_km(
            last_pos_geo[modid][0],
            last_pos_geo[modid][1],
            $live[x].lat,
            $live[x].lon
          ) > 0.1
        ) {
          last_pos_geo[modid] = [
            $live[x].lat,
            $live[x].lon,
            last_pos_geo[modid][2],
            geocode_request_key,
          ];
          update_now = true;
        }
      }
      let position_label =
        typeof last_pos_geo[modid][2] == "undefined"
          ? $live[x].lat + ", " + $live[x].lon
          : last_pos_geo[modid][2];
      let geo_match = searchGeofence($live[x].lat, $live[x].lon, {
        geosMap: $geos_map,
        poli: $poli,
        geos: $geos,
        geosClass: $geos_class,
        classifiedOnly: true,
      });
      let geo_zone_is_match =
        Array.isArray(geo_match) &&
        typeof geo_match[2] != "undefined" &&
        geo_match[2] !== "";
      table_pos_live[modid] = {
        ...$live[x],
        geo_name_: position_label,
        geo_zone_name_: geo_zone_is_match ? geo_match[0] : position_label,
        geo_zone_is_match_: geo_zone_is_match,
        level_c: 0,
      };
      if (update_now) {
        last_pos_geo[modid][3] = geocode_request_key;
        queue_geocode(modid, $live[x].lat, $live[x].lon, geocode_request_key);
      }
    }

    for (let x in live_st) {
      if (typeof $live[x] == "undefined") {
        delete loop_msg[x];
        delete points_pos[x];
        continue;
      }
      if (typeof loop_msg[x] == "undefined") {
        loop_msg[x] = {};
      }
      if (typeof points_pos[x] == "undefined") {
        points_pos[x] = 0;
      }
      let ec1 = get_unit_label(live_st[x].modid);

      if (live_st[x] != $live[x]) {
        points_pos[x] = points_pos[x] + score_config.weight_any_change;
      }
      if (live_st[x].ingnition != $live[x].ingnition) {
        points_pos[x] = points_pos[x] + score_config.weight_ignition_change;
        loop_msg[x]["ing"] = {
          msg:
            ec1 +
            " ignicion " +
            ($live[x].ingnition == 1 ? "encendida" : "apagada"),
          time: 60,
          nick: ec1,
        };
      }
      if (live_st[x].vel == 0 && $live[x].vel > 0) {
        points_pos[x] = points_pos[x] + score_config.weight_movement_start;
        loop_msg[x]["mov"] = {
          msg: ec1 + " inicia movimiento ",
          time: 60,
          nick: ec1,
        };
      }
      if (live_st[x].vel > 0 && $live[x].vel == 0) {
        points_pos[x] = points_pos[x] + score_config.weight_movement_stop;
        loop_msg[x]["mov"] = {
          msg: ec1 + " sin movimiento ",
          time: 60,
          nick: ec1,
        };
      }
      if ($live[x].vel > score_config.high_speed_threshold) {
        points_pos[x] = points_pos[x] + score_config.weight_high_speed;
        loop_msg[x]["mov"] = {
          msg: ec1 + " velocidad alta " + $live[x].vel + " Km/hr",
          time: 60,
          nick: ec1,
        };
      }
      if (
        (now_seconds - live_st[x].last_comm > no_report_seconds_on &&
          live_st[x].ingnition == 1) ||
        (now_seconds - live_st[x].last_comm > no_report_seconds_off &&
          live_st[x].ingnition == 0)
      ) {
        points_pos[x] = points_pos[x] + score_config.weight_no_report;
        loop_msg[x]["time"] = {
          msg:
            ec1 +
            " sin reportar por " +
            parseInt((now_seconds - live_st[x].last_comm) / 60) +
            "min",
          time: 60,
          nick: ec1,
        };
      }
      if (points_pos[x] > 0) points_pos[x] = points_pos[x] - score_config.score_decay;
      if (points_pos[x] < 0) points_pos[x] = 0;
      if (points_pos[x] > score_config.score_max) {
        points_pos[x] = score_config.score_max;
      }
    }

    live_st = { ...$live };
    rebuild_ranked_table(table_pos_live);

    let msg_out_t = "";
    for (let z in loop_msg) {
      for (let w in loop_msg[z]) {
        loop_msg[z][w].time = loop_msg[z][w].time - 1;
        if (
          loop_msg[z][w].time > 0 &&
          table_pos_filter_set.has(loop_msg[z][w].nick)
        ) {
          msg_out_t = msg_out_t + loop_msg[z][w].msg + " | ";
        }
      }
    }
    if (control != null && msg_out_t != "") {
      control.update([() => msg_out_t]);
    } else if (control != null) {
      control.update([() => " Torre de control | "]);
    }
  }

  function get_km(lat1, lon1, lat2, lon2) {
    var R = 6371;
    var dLat = (lat2 - lat1) * (Math.PI / 180);
    var dLon = (lon2 - lon1) * (Math.PI / 180);
    var a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(lat1 * (Math.PI / 180)) *
        Math.cos(lat2 * (Math.PI / 180)) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    var d = R * c;
    return d;
  }

  function sort_units_for_filter_modal() {
    units_list_p = [...$units_list];
    units_list_p.sort(units_order);
  }

  function open_filter_modal() {
    sort_units_for_filter_modal();
    filtro_modal = true;
  }

  function open_score_modal() {
    score_config_form = { ...score_config };
    score_modal = true;
  }

  function save_score_modal() {
    score_config = normalize_score_config(score_config_form);
    score_modal = false;
  }

  function reset_score_modal() {
    score_config_form = { ...default_score_config };
  }

  $: {
    window.localStorage.setItem("filtro_torre", JSON.stringify(table_pos_f));
  }

  $: {
    table_pos_filter_set = new Set(table_pos_f);
  }

  $: {
    window.localStorage.setItem(SCORE_CONFIG_KEY, JSON.stringify(score_config));
  }

  $: if (filtro_modal) {
    $units_list;
    $nicks_list;
    sort_units_for_filter_modal();
  }

  function units_order(a, b) {
    if ($nicks_list[b] < $nicks_list[a]) {
      return 1;
    } else {
      return -1;
    }
    return 0;
  }
</script>

{#if filtro_modal}
  <div
    class="modal fade {filtro_modal ? 'show' : ''}"
    tabindex="-1"
    role="dialog"
    aria-labelledby="modaltitle"
    aria-hidden="true"
    style="padding-right: 17px; display: {filtro_modal
      ? 'block'
      : 'none'}; z-index:1039;"
  >
    <div
      class="modal-dialog modal-dialog-centered modal-sm modal-dialog-scrollable"
      role="document"
    >
      <div class="modal-content" style="min-height: 99%">
        <div class="modal-header">
          <h5 class="modal-title text-center" id="modaltitle">
            <i class="material-icons bblue md-2">directions</i> Lista de
            unidades
            <strong />
          </h5>
        </div>
        <div class="modal-body h-100 p-0">
          <ul class="list-group mx-2">
            {#each units_list_p as item}
              <li class="list-group-item">
                <input
                  type="checkbox"
                  value={get_unit_label(item)}
                  bind:group={table_pos_f}
                />
                {get_unit_label(item)}
              </li>
            {/each}
          </ul>
        </div>
        <div class="modal-footer" style="display: block;">
          <div class="d-flex justify-content-end">
            <div>
              <button
                on:click={() => {
                  filtro_modal = false;
                }}
                class="btn btn-danger big"
                type="button"
              >
                <i class="material-icons md-85">clear</i>
                Cerrar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-backdrop fade show" style="z-index:1038" />
{/if}

{#if score_modal}
  <div
    class="modal fade {score_modal ? 'show' : ''}"
    tabindex="-1"
    role="dialog"
    aria-labelledby="modaltitle-score"
    aria-hidden="true"
    style="padding-right: 17px; display: {score_modal
      ? 'block'
      : 'none'}; z-index:1039;"
  >
    <div
      class="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable"
      role="document"
    >
      <div class="modal-content" style="min-height: 99%">
        <div class="modal-header">
          <h5 class="modal-title text-center" id="modaltitle-score">
            <i class="material-icons bblue md-2">tune</i> Configuración de
            reglas
            <strong />
          </h5>
        </div>
        <div class="modal-body h-100 p-3 w-100">
          <p class="mb-3">
            Ajusta los valores de priorización para el acomodo de unidades.
          </p>
          <div class="alert alert-light border score-help">
            <h6 class="mb-2">
              <i class="material-icons bblue md-1">help_outline</i> Cómo se
              calculan los puntos
            </h6>
            <p class="mb-2">
              Los puntos sirven para decidir qué unidad aparece más arriba.
            </p>
            <ul class="mb-2">
              <li>Si pasa algo importante, la unidad <strong>suma puntos</strong>.</li>
              <li>Entre más puntos tenga, más prioridad tiene en la lista.</li>
              <li>En cada actualización, los puntos <strong>bajan solos</strong>.</li>
            </ul>
            <p class="mb-2">
              Ejemplos de eventos: cambio de ignición, inicio/fin de movimiento,
              velocidad alta o mucho tiempo sin reportar.
            </p>
            <p class="mb-0">
              Tú ajustas:
              <strong>Pesos</strong> = cuántos puntos suma cada evento.
              <strong>Umbrales</strong> = desde qué valor cuenta como evento.
            </p>
          </div>
          <div class="row">
            <div class="col-12 col-lg-6">
              <h6 class="mb-3">
                <i class="material-icons bblue md-1">tune</i> Pesos
              </h6>
              <div class="form-group d-flex align-items-center">
                <label class="form-check-label mr-2 score-label"
                  >Cambio general</label
                >
                <input
                  class="form-control mr-2 score-input"
                  type="number"
                  min="0"
                  bind:value={score_config_form.weight_any_change}
                />
                <label class="form-check-label">Pts</label>
              </div>
              <div class="form-group d-flex align-items-center">
                <label class="form-check-label mr-2 score-label"
                  >Cambio de ignición</label
                >
                <input
                  class="form-control mr-2 score-input"
                  type="number"
                  min="0"
                  bind:value={score_config_form.weight_ignition_change}
                />
                <label class="form-check-label">Pts</label>
              </div>
              <div class="form-group d-flex align-items-center">
                <label class="form-check-label mr-2 score-label"
                  >Inicio de movimiento</label
                >
                <input
                  class="form-control mr-2 score-input"
                  type="number"
                  min="0"
                  bind:value={score_config_form.weight_movement_start}
                />
                <label class="form-check-label">Pts</label>
              </div>
              <div class="form-group d-flex align-items-center">
                <label class="form-check-label mr-2 score-label"
                  >Fin de movimiento</label
                >
                <input
                  class="form-control mr-2 score-input"
                  type="number"
                  min="0"
                  bind:value={score_config_form.weight_movement_stop}
                />
                <label class="form-check-label">Pts</label>
              </div>
              <div class="form-group d-flex align-items-center">
                <label class="form-check-label mr-2 score-label"
                  >Velocidad alta</label
                >
                <input
                  class="form-control mr-2 score-input"
                  type="number"
                  min="0"
                  bind:value={score_config_form.weight_high_speed}
                />
                <label class="form-check-label">Pts</label>
              </div>
              <div class="form-group d-flex align-items-center">
                <label class="form-check-label mr-2 score-label">Sin reporte</label>
                <input
                  class="form-control mr-2 score-input"
                  type="number"
                  min="0"
                  bind:value={score_config_form.weight_no_report}
                />
                <label class="form-check-label">Pts</label>
              </div>
            </div>
            <div class="col-12 col-lg-6">
              <h6 class="mb-3">
                <i class="material-icons bblue md-1">straighten</i> Umbrales
              </h6>
              <div class="form-group d-flex align-items-center">
                <label class="form-check-label mr-2 score-label"
                  >Velocidad alta</label
                >
                <input
                  class="form-control mr-2 score-input"
                  type="number"
                  min="0"
                  bind:value={score_config_form.high_speed_threshold}
                />
                <label class="form-check-label">km/h</label>
              </div>
              <div class="form-group d-flex align-items-center">
                <label class="form-check-label mr-2 score-label"
                  >Sin reporte (ignición ON)</label
                >
                <input
                  class="form-control mr-2 score-input"
                  type="number"
                  min="1"
                  bind:value={score_config_form.no_report_minutes_on}
                />
                <label class="form-check-label">Min</label>
              </div>
              <div class="form-group d-flex align-items-center">
                <label class="form-check-label mr-2 score-label"
                  >Sin reporte (ignición OFF)</label
                >
                <input
                  class="form-control mr-2 score-input"
                  type="number"
                  min="1"
                  bind:value={score_config_form.no_report_minutes_off}
                />
                <label class="form-check-label">Min</label>
              </div>
              <div class="form-group d-flex align-items-center">
                <label class="form-check-label mr-2 score-label"
                  >Decaimiento por ciclo</label
                >
                <input
                  class="form-control mr-2 score-input"
                  type="number"
                  min="0"
                  bind:value={score_config_form.score_decay}
                />
                <label class="form-check-label">Pts</label>
              </div>
              <div class="form-group d-flex align-items-center">
                <label class="form-check-label mr-2 score-label"
                  >Puntaje máximo</label
                >
                <input
                  class="form-control mr-2 score-input"
                  type="number"
                  min="1"
                  bind:value={score_config_form.score_max}
                />
                <label class="form-check-label">Pts</label>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer" style="display: block;">
          <div class="d-flex justify-content-between">
            <button
              on:click={reset_score_modal}
              class="btn btn-secondary big"
              type="button"
            >
              <i class="material-icons md-85">refresh</i>
              Valores iniciales
            </button>
            <div>
              <button
                on:click={() => {
                  score_modal = false;
                }}
                class="btn btn-danger big mr-2"
                type="button"
              >
                <i class="material-icons md-85">clear</i>
                Cerrar
              </button>
              <button
                on:click={save_score_modal}
                class="btn btn-success big"
                type="button"
              >
                <i class="material-icons md-85">save</i>
                Guardar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-backdrop fade show" style="z-index:1038" />
{/if}

<main
  role="main"
  class="container-fluid h-100 pl-0 pr-0 mdc-top-app-bar--dense-fixed-adjust mdc-typography"
>
  <div class="row h-100 no-gutters">
    <div class="d-flex flex-column w-100">
      <div class="card-header b-0 bg-dark text-white card-b">
        <button
          type="button"
          class="btn btn-info mini mx-2 my-1"
          on:click={open_filter_modal}
          ><i class="material-icons md-85">add_circle</i> Filtro de Unidades
        </button>
        <button
          type="button"
          class="btn btn-secondary mini mx-2 my-1"
          on:click={open_score_modal}
          ><i class="material-icons md-85">tune</i> Reglas de prioridad
        </button>
      </div>
      <div class="flex-grow-1">
        <div class="card h-100">
          <div class="card-body h-100 mb-4">
            <div class="tableFixHead h-100">
              <table class="table table-striped table-bordered">
                <thead class="thead-light">
                  <tr>
                    <!--<th scope="col">Nivel</th>-->
                    <th scope="col" />
                    <th scope="col">Económico</th>
                    <th scope="col">Velocidad</th>
                    <th scope="col">Ingnición</th>
                    <th scope="col">Última Posición</th>
                    <th scope="col">Última Posición</th>
                    <th scope="col">GPS</th>
                    <th scope="col">Red Celular</th>
                    <th scope="col">Geocerca/Zona</th>
                  </tr>
                </thead>
                <tbody>
                  {#each table_pos_ as item (item.modid)}
                    {#if typeof item.last_comm !== "undefined"}
                      {#if table_pos_filter_set.has(get_unit_label(item.modid))}
                        <tr>
                          <!--<td>{points_pos[item.modid]}</td>-->
                          <td
                            ><i
                              style="font-weight: bold;"
                              class="material-icons md-24"
                              class:green={item.level_c > 0}
                              class:red={item.level_c < 0}
                              class:gray={item.level_c == 0}
                              >{item.level_c > 0
                                ? "arrow_upward"
                                : item.level_c < 0
                                ? "arrow_downward"
                                : "remove_circle_outline"}</i
                            ></td
                            >
                          <th scope="row"
                            >{get_unit_label(item.modid)}</th
                          >
                          <td
                            class:table-success={item.vel <=
                              score_config.high_speed_threshold &&
                              item.vel != 0}
                            class:table-secondary={item.vel == 0}
                            class:table-danger={item.vel >
                              score_config.high_speed_threshold}
                            >{item.vel} Km/hr</td
                          >
                          <td
                            class:table-success={item.ingnition == 1}
                            class:table-secondary={item.ingnition == 0}
                            >{item.ingnition == "1" ? "ON" : "OFF"}</td
                          >
                          <td
                            class:table-danger={(Date.now() / 1000 -
                              item.last_comm >
                              60 * 15 &&
                              item.ingnition == 1) ||
                              (Date.now() / 1000 - item.last_comm > 60 * 60 &&
                                item.ingnition == 0)}
                            class:table-warning={Date.now() / 1000 -
                              item.last_comm <
                              60 * 15 &&
                              Date.now() / 1000 - item.last_comm > 60 * 10}
                            >{moment(new Date(item.last_comm * 1000)).format(
                              "DD/MM/YY HH:mm:ss"
                            )}</td
                          >
                          <td
                            class:table-danger={(Date.now() / 1000 -
                              item.last_comm >
                              60 * 15 &&
                              item.ingnition == 1) ||
                              (Date.now() / 1000 - item.last_comm > 60 * 60 &&
                                item.ingnition == 0)}
                            class:table-warning={Date.now() / 1000 -
                              item.last_comm <
                              60 * 15 &&
                              Date.now() / 1000 - item.last_comm > 60 * 10}
                            >{parseInt(
                              (Date.now() - item.last_comm * 1000) / 1000 / 60
                            )}min</td
                          >
                          <td
                            class:bg-danger={item.hdop > 1.5}
                            class:table-success={item.hdop <= 1.5}
                            >{item.hdop > 1.5 ? "Malo" : "OK"}</td
                          >
                          <td
                            class:bg-danger={item.rssi >= 100}
                            class:table-success={item.rssi <= 90}
                            class:bg-warning={item.rssi > 90 && item.rssi < 100}
                            >{item.rssi >= 100
                              ? "Malo"
                              : item.rssi > 90
                              ? "Regular"
                              : "Bueno"}</td
                          >
                          <td class:table-success={item.geo_zone_is_match_}
                            >{item.geo_zone_name_}</td
                          >
                        </tr>
                      {/if}
                    {/if}
                  {/each}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="">
        <div id="marquee" />
      </div>
    </div>
  </div>
</main>

<style>
  .btn {
    vertical-align: initial;
    padding: 1px 6px;
    font-size: 0.78rem;
  }
  .card-b {
    border: 0px;
  }
  .tableFixHead {
    overflow-y: auto;
  }
  .tableFixHead thead th {
    position: sticky;
    top: 0;
  }
  .card-body {
    padding: 0rem;
  }
  .card-header.b-0 {
    padding-top: 0.2rem;
    padding-bottom: 0.2rem;
    padding-left: 0.75rem;
  }
  .card-header:first-child {
    border-radius: 0;
  }
  .score-label {
    min-width: 52%;
    margin-bottom: 0;
  }
  .score-input {
    width: 100px;
    max-width: 100px;
  }
  .h-10 {
    height: 10%;
  }
  .h-90 {
    height: 90%;
  }
  #marquee {
    position: fixed;
    overflow: hidden;
    margin: 0;
    padding: 5px 0;
    font-size: 18px;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: #343a40;
    color: #ffffff;
    font-family: Verdana, Geneva, sans-serif;
  }
  @font-face {
    font-family: "Material Icons";
    font-style: normal;
    font-weight: 400;
    src: url(../css/flUhRq6tzZclQEJ-Vdg-IuiaDsNc.woff2) format("woff2");
  }
  .material-icons {
    font-family: "Material Icons";
    font-weight: normal;
    font-style: normal;
    font-size: 24px;
    line-height: 1;
    letter-spacing: normal;
    text-transform: none;
    display: inline-block;
    white-space: nowrap;
    word-wrap: normal;
    direction: ltr;
    -webkit-font-feature-settings: "liga";
    -webkit-font-smoothing: antialiased;
  }
  .material-icons.md-1 {
    font-size: 1rem;
  }
  .material-icons.md-18 {
    font-size: 18px;
  }
  .material-icons.md-24 {
    font-size: 24px;
  }
  .material-icons.md-36 {
    font-size: 36px;
  }
  .material-icons.md-48 {
    font-size: 48px;
  }
  .material-icons.md-85 {
    font-size: 1.3rem;
  }
  .material-icons.md-90 {
    font-size: 1.5rem;
  }
  .material-icons.md-95 {
    font-size: 1.8rem;
  }
  .material-icons.md-dark {
    color: rgba(0, 0, 0, 0.54);
  }
  .material-icons.md-dark.md-inactive {
    color: rgba(0, 0, 0, 0.26);
  }
  .material-icons.md-light {
    color: rgba(255, 255, 255, 1);
  }
  .material-icons.md-light.md-inactive {
    color: rgba(255, 255, 255, 0.3);
  }
  .material-icons.orange {
    color: #ff7043;
  }
  .material-icons.bblue {
    color: #26a69a;
  }
  .material-icons.green {
    color: rgb(24, 179, 45);
  }
  .material-icons.yei {
    color: #ff9800;
  }
  .material-icons.golden {
    color: #856404;
  }
  .material-icons.gray {
    color: #525a63;
  }
  .material-icons.red {
    color: #df1616;
  }
  i {
    vertical-align: middle;
    padding-bottom: 3px;
  }
  span.blue {
    color: rgb(17, 33, 255);
  }
</style>
